'use strict';
import Vue from 'vue'
import Theme from './index.js'

// load up theme components
import MainNav from './main-nav.vue'
import Footer from './footer.vue'
import Sidebar from './sidebar.vue'
Vue.component('theme-main-nav',MainNav)
Vue.component('theme-footer',Footer)
Vue.component('theme-sidebar',Sidebar)

// pass-through: make the theme's primary object available
export default Theme
